import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'
import { DeviceType } from '@/src/types/deviceType'
import { Card } from '@mui/material'
import { useTranslations } from 'next-intl'
import AirlinesFilterWrapperSideBar from './airlinesFilterSideBar'
import ArrivalTimingsFilterWrapper from './arrivalTimings'
import FilterHeaderWrapper from './filterHeader'
import FlightTimingsFilterWrapper from './flightTimings'
import IncludeAirportsFilterWrapper from './includeAirportsFilter'
import { MulticityFilterJourneyScope } from './multicityFilterJourneyScope'
import PriceRangeFilterWrapper from './priceRangeFilter'
import RecommendedFilterWrapper from './recomendedFilter'
import StopsFilterWrapper from './stops'

interface FiltersWrapperProps {
    deviceType: DeviceType
}

const FiltersWrapper = ({ deviceType }: FiltersWrapperProps) => {
    const tHeader = useTranslations('header')
    const tCommon = useTranslations('common')

    return (
        <Card
            sx={{
                bgcolor: 'background.default',
                borderRadius: 1.5,
                border: deviceType === 'DESKTOP' ? 1 : 0,
                borderColor: 'grey.200',
                overflow: 'auto',
                boxShadow: 'none',
                '&::-webkit-scrollbar': {
                    display: 'none'
                },
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
            }}
        >
            <ErrorBoundaryWrapper identifier={`filterHeader-${deviceType}-srp`} fallback={null}>
                <FilterHeaderWrapper tHeader={tHeader} tCommon={tCommon} deviceType={deviceType} />
            </ErrorBoundaryWrapper>

            <ErrorBoundaryWrapper identifier={`recommendedFilter-${deviceType}-srp`} fallback={null}>
                <RecommendedFilterWrapper />
            </ErrorBoundaryWrapper>

            <ErrorBoundaryWrapper identifier={`stopsFilter-${deviceType}-srp`} fallback={null}>
                <StopsFilterWrapper />
            </ErrorBoundaryWrapper>

            <MulticityFilterJourneyScope>
                <ErrorBoundaryWrapper identifier={`flightTimingsFilter-${deviceType}-srp`} fallback={null}>
                    <FlightTimingsFilterWrapper />
                </ErrorBoundaryWrapper>

                <ErrorBoundaryWrapper identifier={`arrivalTimingsFilter-${deviceType}-srp`} fallback={null}>
                    <ArrivalTimingsFilterWrapper />
                </ErrorBoundaryWrapper>
            </MulticityFilterJourneyScope>

            <ErrorBoundaryWrapper identifier={`airlinesFilter-${deviceType}-srp`} fallback={null}>
                <AirlinesFilterWrapperSideBar deviceType={deviceType} />
            </ErrorBoundaryWrapper>

            <ErrorBoundaryWrapper identifier={`priceRangeFilter-${deviceType}-srp`} fallback={null}>
                <PriceRangeFilterWrapper />
            </ErrorBoundaryWrapper>

            <ErrorBoundaryWrapper identifier={`includeAirportsFilter-${deviceType}-srp`} fallback={null}>
                <IncludeAirportsFilterWrapper />
            </ErrorBoundaryWrapper>
        </Card>
    )
}

export default FiltersWrapper
